import React, { useEffect, useState } from "react";
import Sidebar from "../../../../components/user/defaultLayout/Sidebar";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import DataService, {
  API_ENDPOINT,
  imagePath,
} from "../../../../config/DataService";
import { toast } from "react-toastify";
import { Api } from "../../../../config/Api";
import moment from "moment";
import dayjs from "dayjs";
import {
  getAllFamilyWithMohollaNameAndAreaList,
  getCheckAuthenticationDocument,
} from "../../../../redux/features/AddService";
import axios from "axios";
const ariaLabel = { "aria-label": "description" };
const ApplyForSahayView = () => {
  const { sahayApplicationAdminSingleGet } = PagesIndex.useSelector(
    (state) => state.admin,
  );
  const [familyListWithArea, setFamilyListWithArea] = useState([]);
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const { state } = PagesIndex.useLocation();
  const [blobImageUrl, setBlobImgUrl] = useState(null);
  const [getViewData, setGetViewData] = useState(null);

  const initialValues = {};

  const openSecureImageWithAuth = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        const blobUrl = URL.createObjectURL(imageRes.data);
        const ComponentData = "viewsahay";
        navigate("/image-view", {
          state: {
            blobUrl,
            docImageData,
            state,
            ComponentData,
          },
        });
      } else {
        toast.error("Signed URL not received.");
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };

  const renderDocument = (url, filename) => {
    let extension = "";

    if (filename) {
      extension = filename.split(".").pop().toLowerCase();
    } else if (url && url.startsWith("blob:")) {
      extension = ""; // Blob URL cannot detect type without filename
    } else if (url) {
      extension = url.split(".").pop().toLowerCase();
    }
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
      return <img src={url} alt="Document" className="fullscreen-image" />;
    } else if (extension === "pdf") {
      return (
        <iframe
          src={url}
          title="PDF Document"
          className="fullscreen-pdf"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else if (["doc", "docx"].includes(extension)) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url,
          )}`}
          title="Word Document"
          className="fullscreen-doc"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else {
      return <p style={{ color: "#fff" }}>Unsupported or Unknown file type</p>;
    }
  };

  const openSecureImageWithAuthWithoutNavigate = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        setBlobImgUrl(blobUrl);
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };

  useEffect(() => {
    openSecureImageWithAuthWithoutNavigate(getViewData?.application[0]?.image);
  }, [getViewData?.application[0]?.image]);

  // const openSecureImageWithAuth = async (filename) => {
  //   try {
  //     const token = localStorage.getItem("commonToken");

  //     // Step 1: Get encrypted image URL from backend
  //     const res = await axios.get(`${API_ENDPOINT}generate-image-url/${filename}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     const signedUrl = res?.data?.url;

  //     if (signedUrl) {
  //       // Step 2: Fetch image blob manually with token
  //       const imageRes = await axios.get(signedUrl, {
  //         headers: {
  //           Authorization: `Bearer ${token}`, // ✅ token for /protected-image
  //         },
  //         responseType: "blob",
  //       });

  //       // Step 3: Convert blob to object URL
  //       const blobUrl = URL.createObjectURL(imageRes.data);
  //       window.open(blobUrl, "_blank"); // ✅ safe open, URL not exposed
  //     } else {
  //       toast.error("Could not generate secure image URL.");
  //     }
  //   } catch (error) {
  //     console.error("Image open error:", error);
  //     toast.error("Failed to open image.");
  //   }
  // };

  const getSingleSahayApplication = async () => {
    try {
      const response = await DataService.get(
        `${Api.GET_SINGLE_SAHAY_APPLICATION}/${state.id}`,
        // `${Api.GET_SINGLE_SAHAY_APPLICATION}/${state.id[0]}`
      );
      setGetViewData(response.data.data);
    } catch (error) {
      // toast.error(error.response.data.message || error.message);
    }
  };
  useEffect(() => {
    getSingleSahayApplication();
  }, []);

  //back button
  const handleBack = () => {
    navigate("/user/user-listing");
  };

  //Get current financial year
  function getCurrentFinancialYear() {
    var financialYear = "";
    var today = new Date();
    if (today.getMonth() + 1 <= 3) {
      financialYear = today.getFullYear() - 1 + "-" + today.getFullYear();
    } else {
      financialYear = today.getFullYear() + "-" + (today.getFullYear() + 1);
    }
    return financialYear;
  }

  const getFamilyListWithArea = () => {
    const data = {
      mobile: getViewData?.application[0]?.patanMemberMobile,
    };
    dispatch(getAllFamilyWithMohollaNameAndAreaList(data)).then((res) => {
      if (res?.payload) {
        setFamilyListWithArea(res?.payload?.data);
      } else {
        setFamilyListWithArea([]);
      }
    });
  };

  useEffect(() => {
    if (getViewData?.application[0]?.patanMemberMobile?.length >= 10) {
      getFamilyListWithArea();
    }
  }, [getViewData?.application[0]?.patanMemberMobile]);

  return (
    <>
      <Index.Box className="apply-sahay-main">
        <Sidebar />
        <Index.Box className="head-content">
          <Index.Box className="user-right">
            <Index.Box className="bottom-user-right">
              <Index.Box className="page-content-box">
                <Index.Box className="barge-common-box">
                  <Index.Box className="title-header">
                    <Index.Box className="title-header-flex">
                      <Index.Box className="title-main mb-10">
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="page-title"
                        >
                          View Sahay Application
                        </Index.Typography>
                      </Index.Box>
                      <Index.Box sx={{ marginTop: "40px" }}>
                        <Index.Box className="title-header-flex text-end-details">
                          <Index.Box className="common-button blue-button flex-start save-btn  ">
                            <Index.Button
                              variant="contained"
                              onClick={() => handleBack()}
                            >
                              Back
                            </Index.Button>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>

                  <PagesIndex.Formik
                    initialValues={initialValues}
                    enableReinitialize
                  >
                    {({ values }) => (
                      <form>
                        <Index.Box className="">
                          <Index.Grid container spacing={3}>
                            {getViewData?.application[0]?.image && (
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label "
                                >
                                  Image
                                </Index.Typography>
                                <Index.Box
                                  className=" mb-5 mt-5"
                                  style={{
                                    width: "120px",
                                    height: "120",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openSecureImageWithAuth(
                                      getViewData?.application[0]?.image,
                                    )
                                  }
                                >
                                  {renderDocument(
                                    blobImageUrl,
                                    getViewData?.application[0]?.image,
                                  )}
                                  {/* {getViewData?.application[0]?.image && (
                                    <img
                                      style={{ width: "120px", height: "120" }}
                                      src={`${imagePath}${getViewData?.application[0]?.image}`}
                                      className="  mb-5 mt-5"
                                    />
                                  )} */}
                                </Index.Box>
                              </Index.Grid>
                            )}

                            {getViewData?.document
                              ?.map((data) => ({
                                documentType: data.documentType,
                                documents: data.documents?.filter(
                                  (doc) => doc.document !== "null",
                                ),
                              }))
                              ?.filter((item) => item.documents?.length > 0)
                              .length > 0 ? (
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Documents (દસ્તાવેજો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>

                                <Index.Grid item xs={8}>
                                  <Index.Box className="select-view-document-name">
                                    <Index.Box className="select-view-document-name mt-select-doc">
                                      {/* <Index.Box className="select-view-document-name mt-select-doc">
                                  {getViewData?.document
                                    ?.map((data) =>
                                      data?.documents?.filter(
                                        (ele) => ele?.document !== "null"
                                      )
                                    )
                                    .map((item, fileIndex) => {
                                      return (
                                        <>
              
                                          {item?.documentType  &&
                                            item?.documents?.length > 0 && (
                                              <Index.Box className="roles-data-box add-check-flex-doc">
                                                <Index.Box className="add-role-flex">
                                                  <Index.Box className="role-data-title">
                                                    {item.documentType}
                                                  </Index.Box>
                                                </Index.Box>
                                              </Index.Box>
                                            )}
                                          {item?.documents
                                            ?.filter(
                                              (ele) => ele?.document !== "null"
                                            )
                                            .map((document, documentIndex) => (
                                              <Index.Box
                                              className="select-view-document-name mt-select-doc"
                                              key={documentIndex}
                                              >
                                       
                                                <Index.Box className="document-name">
                                                  <Index.Typography
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      window.open(
                                                        document instanceof Blob
                                                          ? URL.createObjectURL(
                                                              document
                                                            )
                                                          : `${imagePath}${document?.filename}`
                                                      );
                                                    }}
                                                  >
                                                    {document instanceof Blob
                                                      ? document.name
                                                      : document?.document}
                                                  </Index.Typography>
                                                  <Index.IconButton
                                                    onClick={() => {
                                                
                                                      // Implement your logic to remove the document
                                                    }}
                                                  >
                                                    <Index.ClearIcon className="muiico-cancel" />
                                                  </Index.IconButton>
                                                </Index.Box>
                                              </Index.Box>
                                            ))}
                                        </>
                                      );
                                    })}
                                </Index.Box> */}

                                      {getViewData?.document
                                        ?.map((data) => ({
                                          documentType: data.documentType,
                                          documents: data.documents?.filter(
                                            (doc) =>
                                              doc.document !== "null" &&
                                              doc.document !== "demo.png",
                                          ),
                                        }))
                                        ?.filter(
                                          (item) => item.documents?.length > 0,
                                        )
                                        ?.map((item, fileIndex) => (
                                          <div key={fileIndex}>
                                            <Index.Box className="roles-data-box add-check-flex-doc">
                                              <Index.Box className="add-role-flex">
                                                <Index.Box className="role-data-title">
                                                  {item.documentType}
                                                </Index.Box>
                                              </Index.Box>
                                            </Index.Box>

                                            {/* Documents List */}
                                            <div>
                                              {item.documents.map(
                                                (document, documentIndex) => (
                                                  <Index.Box
                                                    className="select-view-document-name mt-select-doc"
                                                    key={documentIndex}
                                                  >
                                                    <Index.Box className="document-name">
                                                      <Index.Typography
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          openSecureImageWithAuth(
                                                            document?.filename,
                                                          )
                                                        }
                                                      >
                                                        {document instanceof
                                                        Blob
                                                          ? document.name
                                                          : document?.document ||
                                                            document?.filename}
                                                      </Index.Typography>
                                                    </Index.Box>
                                                  </Index.Box>
                                                ),
                                              )}
                                            </div>
                                          </div>
                                        ))}
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            ) : (
                              ""
                            )}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Basic Details (મૂળભૂત વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Family ID (કૌટુંબિક આઈડી)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="familyId"
                                  disabled
                                  value={state?.mem_family_id}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Addhar Card No. (આધાર કાર્ડ નંબર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.AadharNo}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Sahay Category (શાખાનો પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Sahay Category"
                                  disabled
                                  value={getViewData?.application[0]?.SahayName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Sub Sahay Category (સબ સહાય પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Sahay Category"
                                  disabled
                                  value={
                                    getViewData?.application[0]?.subSahayName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Year Of Sahay (સહાયનું વર્ષ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.Year || "-"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            {getViewData?.application[0]?.PANCardNo ? (
                              <Index.Grid item xs={12} sm={6} md={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  PAN CARD No. (વિસ્તાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.PANCardNo
                                        : getViewData?.application?.[0]
                                            ?.PANCardNo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            ) : (
                              <></>
                            )}

                            {getViewData?.application[0]?.subSahayName ==
                              "Medical Sahay" &&
                            getViewData?.application[0]?.disease !== null ? (
                              <Index.Grid item xs={12} sm={6} md={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Type Of Disease
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    value={
                                      getViewData?.application[0]?.subSahayName
                                        ?.typeOfDisease
                                    }
                                    disabled
                                  />
                                </Index.Box>
                              </Index.Grid>
                            ) : null}

                            {/* <Index.Grid item xs={12} sm={6} md={3}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Application Received Date
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border date-input-box">
                                <Index.LocalizationProvider
                                  dateAdapter={Index.AdapterDayjs}
                                  sx={{ position: "absolute" }}
                                >
                                  <Index.DemoContainer
                                    components={["DatePicker"]}
                                  >
                                    <Index.DatePicker
                                      name="applicationReceiveDate"
                                      // onChange={(value) => {
                                      //   setFieldValue(
                                      //     "applicationReceiveDate",
                                      //     moment(value.$d).format(
                                      //       "YYYY-MM-DD"
                                      //     )
                                      //   );
                                      // }}
                                      value={dayjs(
                                        getViewData?.application[0]
                                          ?.applicationReceiveDate
                                      )}
                                      format="YYYY-MM-DD"
                                      sx={{
                                        overflowY: "hidden",
                                        position: "relative",
                                        bottom: "8px",
                                        width: "100%",
                                      }}
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          error: false,
                                        },
                                      }}
                                    />
                                  </Index.DemoContainer>
                                </Index.LocalizationProvider>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={3}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Filing Date
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border date-input-box">
                                <Index.LocalizationProvider
                                  dateAdapter={Index.AdapterDayjs}
                                  sx={{ position: "absolute" }}
                                >
                                  <Index.DemoContainer
                                    components={["DatePicker"]}
                                  >
                                    <Index.DatePicker
                                      name="formFillingDate"
                                      // onChange={(value) => {
                                      //   setFieldValue(
                                      //     "formFillingDate",
                                      //     moment(value.$d).format(
                                      //       "YYYY-MM-DD"
                                      //     )
                                      //   );
                                      // }}
                                      value={dayjs(
                                        getViewData?.application[0]
                                          ?.formFillingDate
                                      )}
                                      format="YYYY-MM-DD"
                                      sx={{
                                        overflowY: "hidden",
                                        position: "relative",
                                        bottom: "8px",
                                        width: "100%",
                                      }}
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          error: false,
                                        },
                                      }}
                                    />
                                  </Index.DemoContainer>
                                </Index.LocalizationProvider>
                              </Index.Box>
                              {/* {errors?.applicationreceivedate &&
                                  touched.applicationreceivedate && (
                                    <p className="error-text">
                                      {errors?.applicationreceivedate}
                                    </p>
                                  )} 
                            </Index.Grid> */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Family Members Details (પરિવારના સભ્યોની
                                      વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                First Name (પ્રથમ નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="User Name"
                                  disabled
                                  value={getViewData?.application[0]?.firstName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Middle Name (મધ્યમ નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="User Name"
                                  disabled
                                  value={
                                    getViewData?.application[0]?.middleName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Last Name (છેલ્લું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="User Name"
                                  disabled
                                  value={getViewData?.application[0]?.lastName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Relation (સંબંધ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.relation}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Age (ઉંમર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.age
                                      ? getViewData?.application[0]?.age
                                      : "----"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Working Type (કામનો પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.workingType
                                      ? getViewData?.application[0]?.workingType
                                      : "----"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Beneficiary Name (લાભાર્થીનું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={getViewData?.application[0]?.workingType}
                                  value={
                                    getViewData
                                      ? getViewData?.application?.[0]
                                          ?.beneficiaryMemName
                                      : getViewData?.application?.[0]
                                          ?.beneficiaryMemName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Family Income (કૌટુંબિક આવક){" "}
                                <span className="required">*</span>
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={getViewData?.application[0]?.workingType}
                                  value={
                                    getViewData
                                      ? getViewData?.application?.[0]
                                          ?.monthlyIncome
                                      : getViewData?.application?.[0]
                                          ?.monthlyIncome
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Electric Bill amount (ઇલેક્ટ્રિક બિલની રકમ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={getViewData?.application[0]?.workingType}
                                  value={
                                    getViewData
                                      ? getViewData?.application?.[0]
                                          ?.threeMonthBillAmount
                                      : getViewData?.application?.[0]
                                          ?.threeMonthBillAmount || "-"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Bank Details (બેંક વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Bank Name (બેંકનું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.bankName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Branch (શાખા)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.branch}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Account Holder Name (એકાઉન્ટ ધારકનું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.HolderName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Account Number (એકાઉન્ટ નંબર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.AccountNo}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                IFSC code (IFSC કોડ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.IFSCCode}
                                />
                              </Index.Box>
                            </Index.Grid>
                            {getViewData?.application[0]?.mediclaimAmmount !==
                              0 ||
                            getViewData?.application[0]?.SahayAmmount !== 0 ||
                            getViewData?.application[0]?.rentSahayAmmount !==
                              0 ||
                            getViewData?.application[0]?.claimedAmmount !==
                              0 ? (
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Sahay Details (સહાય વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                            ) : (
                              <></>
                            )}

                            {getViewData?.application[0]?.mediclaimAmmount !==
                              0 && (
                              <>
                                {" "}
                                {/* <Index.Grid item xs={12} sm={6} md={5} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Mediclaim Policy Amount
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.mediclaimAmmount
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>{" "} */}
                              </>
                            )}
                            {getViewData?.application[0]?.SahayAmmount !==
                              0 && (
                              <Index.Grid item xs={12} sm={6} md={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Sahay Amount
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Sahay Amount"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.SahayAmmount
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            )}
                            {getViewData?.application[0]?.rentSahayAmmount !==
                              0 && (
                              <>
                                <Index.Grid item xs={12} sm={6} md={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Rent Amount For Rent Sahay
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.rentSahayAmmount
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </>
                            )}
                            {getViewData?.application[0]?.claimedAmmount !==
                              0 && (
                              <>
                                <Index.Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    {/* Claimed Sahay Amount */}
                                    Total Requested Sahay Amount (કુલ વિનંતી
                                    કરેલ સહાય રકમ)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.claimedAmmount
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>{" "}
                              </>
                            )}
                            <Index.Grid item xs={12} sm={8} md={8}>
                              <Index.Box className="lable-input-grp">
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Remark (ટિપ્પણી)
                                </Index.Typography>
                                {/* <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="remark"
                                        value={values?.remark}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                      /> */}
                                <Index.TextareaAutosize
                                  style={{
                                    fontSize: "15px",
                                    color: "black",
                                    padding: "4px",
                                    minHeight: "50px",
                                    width: "100%",
                                  }}
                                  minRows={1}
                                  inputProps={ariaLabel}
                                  className="basic-input input-width"
                                  name="remark"
                                  value={getViewData?.application[0]?.remark}

                                  // onBlur={handleBlur}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Reference / Guarantor (સંદર્ભ / બાંયધરી
                                      આપનાર)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Mobile Number (મોબાઈલ નંબર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]
                                      ?.patanMemberMobile
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                FID (કૌટુંબિક આઈડી)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? getViewData?.PatanMemberData?.[0]
                                  //       ?.mem_family_id
                                  //     : ""
                                  // }
                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile,
                                    )
                                      ? familyListWithArea?.find(
                                          (row) =>
                                            row?.mem_mobile ==
                                            getViewData?.application[0]
                                              ?.patanMemberMobile,
                                        )?.mem_family_id
                                      : ""
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Reference / Guarantor (સંદર્ભ / બાંયધરી આપનાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? `${getViewData?.PatanMemberData?.[0]?.mem_fname} ${getViewData?.PatanMemberData?.[0]?.mem_mname} ${getViewData?.PatanMemberData?.[0]?.mem_lname}`
                                  //     : getViewData?.application[0]
                                  //       ?.patanReferenceName
                                  // }

                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile,
                                    )
                                      ? `${
                                          familyListWithArea.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile,
                                          )?.mem_fname
                                        } ${
                                          familyListWithArea.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile,
                                          )?.mem_mname
                                        } ${
                                          familyListWithArea.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile,
                                          )?.mem_lname
                                        }`
                                      : values?.patanReferenceName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Mohalla Name (મહોલ્લો નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? getViewData?.PatanMemberData?.[0]
                                  //       ?.mohollo_name
                                  //     : getViewData?.application[0]
                                  //       ?.patanReferenceMohollo
                                  // }
                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile,
                                    )
                                      ? familyListWithArea?.find(
                                          (row) =>
                                            row?.mem_mobile ==
                                            getViewData?.application[0]
                                              ?.patanMemberMobile,
                                        )?.mohollo_name
                                      : values?.patanReferenceMohollo
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Area (વિસ્તાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? getViewData?.PatanMemberData?.[0]
                                  //       ?.family_area
                                  //     : getViewData?.application[0]
                                  //       ?.patanReferenceArea
                                  // }
                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile,
                                    )
                                      ? familyListWithArea?.find(
                                          (row) =>
                                            row?.mem_mobile ==
                                            getViewData?.application[0]
                                              ?.patanMemberMobile,
                                        )?.family_area
                                      : values?.patanReferenceArea
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            {/* Policy Holders' Details (પોલીસી ધારકોની વિગતઃ) */}
                            {getViewData?.application[0]?.subSahayName?.toLowerCase() ==
                              "mediclaim premium sahay" && (
                              <>
                                <Index.Grid item xs={12} md={12}>
                                  <Index.Box className="title-header" mt={5}>
                                    <Index.Box className="title-header-flex res-title-header-flex">
                                      <Index.Box className="title-main">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Policy Holders' Details (પોલીસી
                                          ધારકોની વિગતઃ)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box className="">
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table
                                        aria-label="simple table"
                                        className="table-design-main barge-table "
                                      >
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Full Name (પુરું નામ)
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {" "}
                                              Relationship (સંબંધ)
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {" "}
                                              Age (ઉંમર)
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {" "}
                                              Sum Insured (વીમાની રકમ)
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {" "}
                                              Total Premium (કુલ પ્રીમિયમ)
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.policyHolders?.length >
                                          0 ? (
                                            getViewData?.policyHolders?.map(
                                              (data, index) => {
                                                return (
                                                  <Index.TableRow key={index}>
                                                    <Index.TableCell>
                                                      {data?.fullName || "-"}
                                                    </Index.TableCell>
                                                    <Index.TableCell align="left">
                                                      {data?.relationship ||
                                                        "-"}
                                                    </Index.TableCell>
                                                    <Index.TableCell align="left">
                                                      {data?.age || "-"}
                                                    </Index.TableCell>
                                                    <Index.TableCell align="left">
                                                      {data?.sumInsured || "-"}
                                                    </Index.TableCell>
                                                    <Index.TableCell align="left">
                                                      {data?.totalPremium ||
                                                        "-"}
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                );
                                              },
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                scope="row"
                                                className="no-data-in-list"
                                                colSpan={6}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Insurance Information Section */}
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Box className="main-in-row">
                                      <Index.Box className="user-basic"></Index.Box>
                                      <Index.Box
                                        sx={{ flexGrow: 1 }}
                                        className="al-form-groups family-detail"
                                      >
                                        <Index.Grid container spacing={2}>
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                          >
                                            <Index.Box className="title-header">
                                              <Index.Box className="title-header-flex">
                                                <Index.Box className="title-main ">
                                                  <Index.Typography
                                                    variant="p"
                                                    component="p"
                                                    className="page-title"
                                                  >
                                                    Insurance Information (વીમા
                                                    માહિતી)
                                                  </Index.Typography>
                                                </Index.Box>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>
                                          {/* Insurance Co. Name */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Insurance Co. Name (ઈન્સ્યુરન્સ
                                                કું. નું નામ)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.TextField
                                                  inputProps={ariaLabel}
                                                  className="basic-input input-width"
                                                  name="insuranceCompanyName"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.insuranceCompanyName ||
                                                    ""
                                                  }
                                                  disabled
                                                  fullWidth
                                                />
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Branch No. */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Branch No. (બ્રાન્ચ નં.)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.TextField
                                                  inputProps={ariaLabel}
                                                  className="basic-input input-width"
                                                  name="branchNumber"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.branchNumber || ""
                                                  }
                                                  disabled
                                                  fullWidth
                                                />
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Policy No. */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Policy No. (પોલીસી નં.)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.TextField
                                                  className="basic-input input-width"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.policyNumber || ""
                                                  }
                                                  name="policyNumber"
                                                  inputProps={ariaLabel}
                                                  fullWidth
                                                  disabled
                                                />
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Place */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Place (સ્થળ)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.TextField
                                                  inputProps={ariaLabel}
                                                  className="basic-input input-width"
                                                  name="place"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.place || ""
                                                  }
                                                  fullWidth
                                                  disabled
                                                />
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Total Premium Paid */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Total Premium Paid (Rs.) (ભરેલ
                                                કુલ પ્રીમિયમ રૂ.)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.TextField
                                                  inputProps={ariaLabel}
                                                  className="basic-input input-width"
                                                  name="totalPremiumPaid"
                                                  type="number"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.totalPremiumPaid || ""
                                                  }
                                                  fullWidth
                                                  disabled
                                                />
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Policy Term: From */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Policy Term: From (પોલીસીની મુદત
                                                તા)
                                              </Index.Typography>
                                              <Index.Box className="input-design-div with-border date-input-box">
                                                <Index.LocalizationProvider
                                                  dateAdapter={
                                                    Index.AdapterDayjs
                                                  }
                                                >
                                                  <Index.DemoContainer
                                                    components={["DatePicker"]}
                                                    sx={{
                                                      position: "absolute",
                                                    }}
                                                  >
                                                    <Index.DatePicker
                                                      name="policyTermFrom"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.policyTermFrom
                                                          ? dayjs(
                                                              getViewData
                                                                ?.application[0]
                                                                .policyTermFrom,
                                                            )
                                                          : null
                                                      }
                                                      format="YYYY-MM-DD"
                                                      sx={{
                                                        overflowY: "hidden",
                                                        position: "relative",
                                                        bottom: "8px",
                                                        width: "100%",
                                                      }}
                                                      slotProps={{
                                                        textField: {
                                                          size: "small",
                                                          error: false,
                                                        },
                                                      }}
                                                      disabled
                                                    />
                                                  </Index.DemoContainer>
                                                </Index.LocalizationProvider>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Policy Term: To */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Policy Term: To (પોલીસીની મુદત
                                                સુધી)
                                              </Index.Typography>
                                              <Index.Box className="input-design-div with-border date-input-box">
                                                <Index.LocalizationProvider
                                                  dateAdapter={
                                                    Index.AdapterDayjs
                                                  }
                                                >
                                                  <Index.DemoContainer
                                                    components={["DatePicker"]}
                                                  >
                                                    <Index.DatePicker
                                                      name="policyTermTo"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.policyTermTo
                                                          ? dayjs(
                                                              getViewData
                                                                ?.application[0]
                                                                ?.policyTermTo,
                                                            )
                                                          : null
                                                      }
                                                      format="YYYY-MM-DD"
                                                      sx={{
                                                        width: "100%",
                                                      }}
                                                      slotProps={{
                                                        textField: {
                                                          size: "small",
                                                          error: false,
                                                        },
                                                      }}
                                                      disabled
                                                    />
                                                  </Index.DemoContainer>
                                                </Index.LocalizationProvider>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Last Year Details: During the last year up to Rs. */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Last Year Details: During the
                                                last year up to Rs. (ગત વર્ષ
                                                દરમિયાન રૂ. સુધી)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.TextField
                                                  inputProps={ariaLabel}
                                                  className="basic-input input-width"
                                                  name="lastYearAmount"
                                                  type="number"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.lastYearAmount || ""
                                                  }
                                                  fullWidth
                                                  disabled
                                                />
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Last Year Details: until Date */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                until Date (તારીખ સુધી)
                                              </Index.Typography>
                                              <Index.Box className="input-design-div with-border date-input-box">
                                                <Index.LocalizationProvider
                                                  dateAdapter={
                                                    Index.AdapterDayjs
                                                  }
                                                >
                                                  <Index.DemoContainer
                                                    components={["DatePicker"]}
                                                  >
                                                    <Index.DatePicker
                                                      name="lastYearUntilDate"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.lastYearUntilDate
                                                          ? dayjs(
                                                              getViewData
                                                                ?.application[0]
                                                                .lastYearUntilDate,
                                                            )
                                                          : null
                                                      }
                                                      format="YYYY-MM-DD"
                                                      sx={{
                                                        width: "100%",
                                                      }}
                                                      slotProps={{
                                                        textField: {
                                                          size: "small",
                                                          error: false,
                                                        },
                                                      }}
                                                      disabled
                                                    />
                                                  </Index.DemoContainer>
                                                </Index.LocalizationProvider>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Policy Type */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Policy Type (પોલિસીનો પ્રકાર)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.FormControl
                                                  sx={{ width: "100%" }}
                                                  className="main-select"
                                                >
                                                  <Index.Select
                                                    className="select-drop"
                                                    displayEmpty
                                                    name="policyTypeSelect"
                                                    value={
                                                      getViewData
                                                        ?.application[0]
                                                        ?.policyTypeSelect || ""
                                                    }
                                                    input={
                                                      <Index.OutlinedInput />
                                                    }
                                                    // MenuProps={MenuProps}
                                                    disabled
                                                  >
                                                    <Index.MenuItem value="">
                                                      <em>Select Type</em>
                                                    </Index.MenuItem>
                                                    <Index.MenuItem value="new">
                                                      New
                                                    </Index.MenuItem>
                                                    <Index.MenuItem value="renewal">
                                                      Renewal
                                                    </Index.MenuItem>
                                                  </Index.Select>
                                                </Index.FormControl>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>

                                          {/* Claim History */}
                                          <Index.Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Index.Box className="lable-input-grp">
                                              <Index.Typography
                                                component="p"
                                                className="in-label"
                                              >
                                                Claim History: Claim has been
                                                received (ક્લેઇમ મેળવેલ છે)
                                              </Index.Typography>
                                              <Index.Box className="sahay-multiple-input-main">
                                                <Index.RadioGroup
                                                  row
                                                  name="claimReceived"
                                                  value={
                                                    getViewData?.application[0]
                                                      ?.claimReceived || ""
                                                  }
                                                  disabled
                                                >
                                                  <Index.FormControlLabel
                                                    value="yes"
                                                    control={<Index.Radio />}
                                                    label="Yes"
                                                  />
                                                  <Index.FormControlLabel
                                                    value="no"
                                                    control={<Index.Radio />}
                                                    label="No"
                                                  />
                                                </Index.RadioGroup>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Grid>
                                        </Index.Grid>
                                      </Index.Box>
                                    </Index.Box>

                                    {/* Important Notes Section */}
                                    <Index.Box
                                      className="notes-section"
                                      sx={{
                                        mt: 4,
                                        p: 2,
                                        border: "1px solid #ddd",
                                        borderRadius: 1,
                                      }}
                                    >
                                      <Index.Typography
                                        className="note-title"
                                        sx={{ fontWeight: "bold", mb: 2 }}
                                      >
                                        Important Notes (મહત્વની નોંધ)
                                      </Index.Typography>

                                      <Index.Box className="note-points">
                                        {/* Point 1 */}
                                        <Index.Typography
                                          className="note-point"
                                          sx={{ mb: 1.5 }}
                                        >
                                          (1) It is mandatory to send the
                                          receipt of the amount paid to the
                                          Insurance Co. and a photocopy of the
                                          policy along with the application
                                          form.
                                          <br />
                                          (ઈન્સ્યુરન્સ કું. માં ભરેલ રકમની રસીદ
                                          તથા પોલીસીની ઝેરોક્ષ, અરજી પત્રક સાથે
                                          મોકલવી જરૂરી છે.)
                                        </Index.Typography>

                                        {/* Point 2 */}
                                        <Index.Typography
                                          className="note-point"
                                          sx={{ mb: 1.5 }}
                                        >
                                          (2) This form must be filled and sent
                                          to the association's office within
                                          four months from the date of minimum
                                          payment.
                                          <br />
                                          (મિનિમમ લાયકાતની તારીખથી ચાર માસ
                                          સુધીમાં આ ફોર્મ ભરીને મંડળના
                                          કાર્યાલયમાં મોકલવા જરૂરી છે.)
                                        </Index.Typography>

                                        {/* Point 3 */}
                                        <Index.Typography
                                          className="note-point"
                                          sx={{ mb: 1.5 }}
                                        >
                                          (3) Applications received after that
                                          period will not be accepted.
                                          <br />
                                          (ત્યારબાદ મળેલ અરજી સ્વીકાર્ય ગણાશે
                                          નહીં.)
                                        </Index.Typography>

                                        {/* Point 4 - Radio buttons */}
                                        {/* <Index.Box
                                          className="note-point-with-input"
                                          sx={{ mb: 1.5 }}
                                        >
                                          <Index.Typography component="p">
                                            (4) Have you taken an SBI General
                                            Mediclaim Policy through the
                                            association?
                                            <br />
                                            (મંડળ દ્વારા SBI જનરલ મેડિકલેઈમ
                                            પોલીસી લીધી છે?)
                                          </Index.Typography>
                                          <Index.RadioGroup
                                            row
                                            name="sbiPolicyTaken"
                                            value={
                                              getViewData?.application[0]
                                                ?.sbiPolicyTaken || ""
                                            }
                                            disabled
                                          >
                                            <Index.FormControlLabel
                                              value="yes"
                                              control={<Index.Radio />}
                                              label="Yes (હા)"
                                            />
                                            <Index.FormControlLabel
                                              value="no"
                                              control={<Index.Radio />}
                                              label="No (ના)"
                                            />
                                          </Index.RadioGroup>
                                        </Index.Box> */}

                                        {/* Point 5 - Text input */}
                                        <Index.Box
                                          className="note-point-with-input"
                                          sx={{ mb: 1.5 }}
                                        >
                                          <Index.Typography
                                            component="p"
                                            sx={{ mb: 0.5 }}
                                          >
                                            (4) Reason for taking the policy
                                            (પોલીસી લેવાનું કારણ):
                                          </Index.Typography>
                                          <Index.TextField
                                            fullWidth
                                            name="policyReason"
                                            value={
                                              getViewData?.application[0]
                                                ?.policyReason || ""
                                            }
                                            disabled
                                            className="basic-input"
                                            placeholder="Enter reason..."
                                            multiline
                                            rows={2}
                                          />
                                        </Index.Box>

                                        {/* Point 6 - Radio buttons */}
                                        <Index.Box
                                          className="note-point-with-input"
                                          sx={{ mb: 1.5 }}
                                        >
                                          <Index.Typography
                                            component="p"
                                            sx={{ mb: 0.5 }}
                                          >
                                            (5) Policy Category (પોલીસીનો
                                            પ્રકાર):
                                          </Index.Typography>
                                          <Index.RadioGroup
                                            row
                                            name="policyCategory"
                                            value={
                                              getViewData?.application[0]
                                                ?.policyCategory || ""
                                            }
                                            disabled
                                          >
                                            <Index.FormControlLabel
                                              value="group"
                                              control={<Index.Radio />}
                                              label="Group Policy (ગ્રુપ પોલીસી)"
                                            />
                                            <Index.FormControlLabel
                                              value="individual"
                                              control={<Index.Radio />}
                                              label="Individual Policy (ઈન્ડીવિજ્યુઅલ પોલીસી)"
                                            />
                                          </Index.RadioGroup>
                                        </Index.Box>

                                        {/* Point 7 */}
                                        <Index.Typography
                                          component="p"
                                          className="note-point"
                                          sx={{
                                            fontWeight: "bold",
                                            color: "error.main",
                                          }}
                                        >
                                          (6) All details have been carefully
                                          verified in writing. Forms with
                                          incomplete details will not be
                                          considered.
                                          <br />
                                          (કોઈપણ વિગત ખોટી લખી છે તો તે માન્ય
                                          રહેશે નહીં. અધૂરી વિગતોવાળા ફોર્મ પર
                                          ધ્યાન આપવામાં આવશે નહીં.)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </>
                            )}

                            {/* Medicine Sahay Guidelines and Instructions  */}
                            {getViewData?.application[0]?.subSahayName?.toLowerCase() ==
                              "medicine sahay" && (
                              <>
                                {/* Insurance Information Section */}
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Box className="main-in-row">
                                      <Index.Box className="user-basic"></Index.Box>
                                      <Index.Box
                                        sx={{ flexGrow: 1 }}
                                        className="family-detail"
                                      >
                                        {/* Guidelines and Instructions */}
                                        <Index.Box
                                          // className="guidelines-section"
                                          sx={{
                                            mb: 3,
                                            p: 2,
                                            bgcolor: "#f5f5f5",
                                            borderRadius: 1,
                                          }}
                                        >
                                          <Index.Typography
                                            component="h3"
                                            sx={{
                                              fontWeight: "bold",
                                              mb: 1.5,
                                              fontSize: "16px",
                                            }}
                                          >
                                            Guidelines and Instructions
                                            (માર્ગદર્શિકા અને સૂચનાઓ)
                                          </Index.Typography>

                                          <Index.Box
                                            component="ul"
                                            sx={{
                                              pl: 2,
                                              "& li": {
                                                mb: 0.5,
                                                fontSize: "14px",
                                              },
                                            }}
                                          >
                                            <li>
                                              A maximum of four months' worth of
                                              bills may be submitted with the
                                              application.
                                              <br />
                                              (અરજી સાથે મહત્તમ ચાર મહિનાના
                                              બિલ્સ સબમિટ કરી શકાય છે.)
                                            </li>
                                            <li>
                                              Applicant must provide original
                                              bills and a photocopy of the
                                              doctor's prescription.
                                              <br />
                                              (અરજદારે મૂળ બિલ્સ અને ડૉક્ટરના
                                              પ્રિસ્ક્રિપ્શનની ફોટોકોપી આપવી
                                              જરૂરી છે.)
                                            </li>
                                            <li>
                                              Detailed information regarding
                                              other expenses must be recorded on
                                              this back of the form.
                                              <br />
                                              (અન્ય ખર્ચા અંગેની વિગતવાર માહિતી
                                              આ ફોર્મની પાછળની બાજુએ નોંધવી
                                              જરૂરી છે.)
                                            </li>
                                            <li>
                                              Multiple claims may be submitted,
                                              but not more than once every six
                                              months.
                                              <br />
                                              (બહુવિધ દાવાઓ સબમિટ કરી શકાય છે,
                                              પરંતુ દર છ મહિનામાં એક વાર કરતાં
                                              વધુ નહીં.)
                                            </li>
                                            <li>
                                              Applications without a current
                                              prescription will not be
                                              considered.
                                              <br />
                                              (વર્તમાન પ્રિસ્ક્રિપ્શન વિનાની
                                              અરજીઓ પર વિચારણા કરવામાં આવશે
                                              નહીં.)
                                            </li>
                                            <li>
                                              If monthly expenses are up to Rs.
                                              2000, apply every three months.
                                              <br />
                                              (જો માસિક ખર્ચ રૂ. 2000 સુધી હોય,
                                              તો દર ત્રણ મહિને અરજી કરો.)
                                            </li>
                                            <li>
                                              If monthly expenses are up to Rs.
                                              5000, apply every six months.
                                              <br />
                                              (જો માસિક ખર્ચ રૂ. 5000 સુધી હોય,
                                              તો દર છ મહિને અરજી કરો.)
                                            </li>
                                            <li>
                                              Application must be given to this
                                              said address within one year.
                                              <br />
                                              (અરજી એક વર્ષની અંદર આ સરનામે આપવી
                                              જરૂરી છે.)
                                            </li>
                                          </Index.Box>

                                          {/* Direct Medicine Scheme - Inline in Guidelines */}
                                          <Index.Box
                                            sx={{
                                              mt: 2,
                                              p: 2,
                                              bgcolor: "#fff3cd",
                                              borderRadius: 1,
                                              border: "1px solid #ffc107",
                                            }}
                                          >
                                            <Index.Grid
                                              container
                                              spacing={2}
                                              alignItems="center"
                                            >
                                              <Index.Grid item xs={12} sm={6}>
                                                <Index.Typography
                                                  component="p"
                                                  sx={{ fontWeight: "bold" }}
                                                >
                                                  <strong>
                                                    Direct Medicine Scheme:
                                                  </strong>{" "}
                                                  (ડાયરેક્ટ મેડિસિન યોજના)
                                                </Index.Typography>
                                              </Index.Grid>

                                              <Index.Grid item xs={12} sm={3}>
                                                <Index.Box>
                                                  <Index.Typography
                                                    component="span"
                                                    sx={{ mr: 1 }}
                                                  >
                                                    Joined? (જોડાયા?)
                                                  </Index.Typography>
                                                  <Index.RadioGroup
                                                    row
                                                    name="directMedicineSchemeJoined"
                                                    value={
                                                      getViewData
                                                        ?.application[0]
                                                        ?.directMedicineSchemeJoined ||
                                                      ""
                                                    }
                                                    disabled
                                                    // onChange={handleChange}
                                                  >
                                                    <Index.FormControlLabel
                                                      value="yes"
                                                      control={
                                                        <Index.Radio size="small" />
                                                      }
                                                      label="Yes (હા)"
                                                    />
                                                    <Index.FormControlLabel
                                                      value="no"
                                                      control={
                                                        <Index.Radio size="small" />
                                                      }
                                                      label="No (ના)"
                                                    />
                                                  </Index.RadioGroup>
                                                </Index.Box>
                                              </Index.Grid>

                                              <Index.Grid item xs={12} sm={3}>
                                                {getViewData?.application[0]
                                                  ?.directMedicineSchemeJoined ===
                                                  "no" && (
                                                  <Index.Box>
                                                    <Index.Typography
                                                      component="span"
                                                      sx={{ mr: 1 }}
                                                    >
                                                      Reason (કારણ):
                                                    </Index.Typography>
                                                    <Index.TextField
                                                      size="small"
                                                      name="directMedicineSchemeReason"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.directMedicineSchemeReason ||
                                                        ""
                                                      }
                                                      disabled
                                                      // onChange={handleChange}
                                                      // placeholder="Enter reason"
                                                      sx={{ width: "100%" }}
                                                    />
                                                  </Index.Box>
                                                )}
                                              </Index.Grid>
                                            </Index.Grid>
                                          </Index.Box>
                                        </Index.Box>

                                        {/* Summary of Medical Bills Table */}
                                        <Index.Grid item xs={12} md={12}>
                                          <Index.Box
                                            className="title-header"
                                            mt={5}
                                          >
                                            <Index.Box className="title-header-flex res-title-header-flex">
                                              <Index.Box className="title-main">
                                                <Index.Typography
                                                  variant="p"
                                                  component="p"
                                                  className="page-title"
                                                >
                                                  Summary of Medical Bills
                                                  (તબીબી બિલ્સનો સારાંશ)
                                                </Index.Typography>
                                              </Index.Box>
                                            </Index.Box>
                                          </Index.Box>
                                          <Index.Box className="">
                                            <Index.TableContainer
                                              component={Index.Paper}
                                              className="table-container"
                                            >
                                              <Index.Table
                                                aria-label="simple table"
                                                className="table-design-main barge-table "
                                              >
                                                <Index.TableHead>
                                                  <Index.TableRow>
                                                    <Index.TableCell>
                                                      Name of Medical Store
                                                      (તબીબી સ્ટોરનું નામ)
                                                    </Index.TableCell>
                                                    <Index.TableCell align="left">
                                                      {" "}
                                                      Date (તારીખ)
                                                    </Index.TableCell>
                                                    <Index.TableCell align="left">
                                                      {" "}
                                                      Bill Amount (બિલ રકમ)
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                </Index.TableHead>
                                                <Index.TableBody>
                                                  {getViewData?.medicalBills
                                                    ?.length > 0 ? (
                                                    getViewData?.medicalBills?.map(
                                                      (data, index) => {
                                                        return (
                                                          <Index.TableRow
                                                            key={index}
                                                          >
                                                            <Index.TableCell>
                                                              {data?.storeName ||
                                                                "-"}
                                                            </Index.TableCell>
                                                            <Index.TableCell align="left">
                                                              {data?.date ||
                                                                "-"}
                                                            </Index.TableCell>
                                                            <Index.TableCell align="left">
                                                              {data?.amount ||
                                                                "-"}
                                                            </Index.TableCell>
                                                          </Index.TableRow>
                                                        );
                                                      },
                                                    )
                                                  ) : (
                                                    <Index.TableRow>
                                                      <Index.TableCell
                                                        component="td"
                                                        variant="td"
                                                        scope="row"
                                                        className="no-data-in-list"
                                                        colSpan={6}
                                                        align="center"
                                                      >
                                                        No data available
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  )}
                                                </Index.TableBody>
                                              </Index.Table>
                                            </Index.TableContainer>
                                          </Index.Box>
                                        </Index.Grid>

                                        {/* Assistance from Other Organizations */}
                                        <Index.Box
                                          className="assistance-section"
                                          sx={{
                                            mb: 3,
                                            p: 2,
                                            border: "1px solid #ddd",
                                            borderRadius: 1,
                                          }}
                                        >
                                          <Index.Typography
                                            component="h3"
                                            sx={{
                                              fontWeight: "bold",
                                              mb: 2,
                                              fontSize: "16px",
                                            }}
                                          >
                                            Assistance from Other Organizations
                                            (અન્ય સંસ્થાઓ તરફથી સહાય)
                                          </Index.Typography>

                                          <Index.Box sx={{ mb: 2 }}>
                                            <Index.Typography
                                              component="p"
                                              sx={{ mb: 1 }}
                                            >
                                              Have you received aid from other
                                              unions/organizations? [ ] Yes [ ]
                                              No
                                              <br />
                                              (શું તમે અન્ય યુનિયન/સંસ્થાઓ
                                              પાસેથી સહાય મેળવી છે? [ ] હા [ ]
                                              ના)
                                            </Index.Typography>

                                            <Index.RadioGroup
                                              row
                                              name="receivedAidFromOthers"
                                              value={
                                                getViewData?.application[0]
                                                  ?.receivedAidFromOthers || ""
                                              }
                                              disabled
                                              // onChange={handleChange}
                                            >
                                              <Index.FormControlLabel
                                                value="yes"
                                                control={<Index.Radio />}
                                                label="Yes (હા)"
                                              />
                                              <Index.FormControlLabel
                                                value="no"
                                                control={<Index.Radio />}
                                                label="No (ના)"
                                              />
                                            </Index.RadioGroup>
                                          </Index.Box>

                                          {/* Conditional rendering when Yes is selected */}
                                          {getViewData?.application[0]
                                            ?.receivedAidFromOthers ===
                                            "yes" && (
                                            <Index.Box className="assistance-details">
                                              <Index.Grid container spacing={2}>
                                                <Index.Grid item xs={12} sm={6}>
                                                  <Index.Box>
                                                    <Index.Typography
                                                      component="p"
                                                      sx={{ mb: 0.5 }}
                                                    >
                                                      1. Name (નામ):
                                                    </Index.Typography>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      name="assistanceOrg1Name"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.assistanceOrg1Name ||
                                                        ""
                                                      }
                                                      disabled
                                                      // onChange={handleChange}
                                                      placeholder="Organization Name"
                                                    />
                                                  </Index.Box>
                                                </Index.Grid>

                                                <Index.Grid item xs={12} sm={6}>
                                                  <Index.Box>
                                                    <Index.Typography
                                                      component="p"
                                                      sx={{ mb: 0.5 }}
                                                    >
                                                      Amount (રકમ):
                                                    </Index.Typography>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      type="number"
                                                      name="assistanceOrg1Amount"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.assistanceOrg1Amount ||
                                                        ""
                                                      }
                                                      disabled
                                                      // onChange={handleChange}
                                                      placeholder="Amount"
                                                      inputProps={{
                                                        min: 0,
                                                        step: 0.01,
                                                      }}
                                                    />
                                                  </Index.Box>
                                                </Index.Grid>

                                                <Index.Grid item xs={12} sm={6}>
                                                  <Index.Box>
                                                    <Index.Typography
                                                      component="p"
                                                      sx={{ mb: 0.5 }}
                                                    >
                                                      2. Name (નામ):
                                                    </Index.Typography>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      name="assistanceOrg2Name"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.assistanceOrg2Name ||
                                                        ""
                                                      }
                                                      disabled
                                                      // onChange={handleChange}
                                                      placeholder="Organization Name"
                                                    />
                                                  </Index.Box>
                                                </Index.Grid>

                                                <Index.Grid item xs={12} sm={6}>
                                                  <Index.Box>
                                                    <Index.Typography
                                                      component="p"
                                                      sx={{ mb: 0.5 }}
                                                    >
                                                      Amount (રકમ):
                                                    </Index.Typography>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      type="number"
                                                      name="assistanceOrg2Amount"
                                                      value={
                                                        getViewData
                                                          ?.application[0]
                                                          ?.assistanceOrg2Amount ||
                                                        ""
                                                      }
                                                      // onChange={handleChange}
                                                      disabled
                                                      placeholder="Amount"
                                                      inputProps={{
                                                        min: 0,
                                                        step: 0.01,
                                                      }}
                                                    />
                                                  </Index.Box>
                                                </Index.Grid>
                                              </Index.Grid>
                                            </Index.Box>
                                          )}
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </>
                            )}

                            {/* After the existing Family Members Details table, add this new section: */}

                            {getViewData?.application[0]?.subSahayName?.toLowerCase() ===
                              "medical sahay" && (
                              <>
                                {/* Medical Sahay - Family Members Living Together */}
                                <Index.Grid item xs={12} md={12}>
                                  <Index.Box className="title-header" mt={5}>
                                    <Index.Box className="title-header-flex res-title-header-flex">
                                      <Index.Box className="title-main">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Details of the Applicant and Persons
                                          Residing with Them (અરજદાર અને તેમની
                                          સાથે રહેતા વ્યક્તિઓની વિગતો)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box className="">
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table
                                        aria-label="simple table"
                                        className="table-design-main barge-table"
                                      >
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              No.
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Full Name (પુરું નામ)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Relation (સંબંધ)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Age (ઉંમર)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Current Activity (વર્તમાન
                                              પ્રવૃત્તિ)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Monthly Income (માસિક આવક)
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.familyMembersDetails?.length >
                                          0 ? (
                                            getViewData.medicalSahay.familyMembersDetails.map(
                                              (member, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {index + 1}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {member?.fullName || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {member?.relation || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {member?.age || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {member?.currentActivity ||
                                                      "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {member?.monthlyIncome ||
                                                      "-"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                scope="row"
                                                className="no-data-in-list"
                                                colSpan={6}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Medical Details Section */}
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Medical Details (તબીબી વિગતો)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Total Family Members (કુલ કુટુંબના
                                          સભ્યો)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.totalFamilyMembers || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Earning Members (કમાતા સભ્યો)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.earningMembers || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Main Ailment Details (મુખ્ય બિમારીની
                                          વિગત)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.mainAilmentDetails || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Other Ailments (અન્ય બિમારીઓ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.otherAilmentsDetails || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Illness Duration (બિમારીનો સમયગાળો)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.illnessDuration || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Family Doctor Name (કૌટુંબિક ડોક્ટરનું
                                          નામ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.familyDoctorName || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Doctor Mobile (ડોક્ટર મોબાઇલ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.familyDoctorMobile || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Operation Details (ઓપરેશન વિગત)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.operationPerformed || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Doctor/Consultant Name
                                          (ડૉક્ટર/સલાહકારનું નામ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.doctorConsultantName || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Hospital/Nursing Home
                                          (હૉસ્પિટલ/નર્સિંગ હોમ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.hospitalNursingHomeName || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Expense Tables */}
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Medication Expenses (દવાનો ખર્ચ)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid item xs={12}>
                                        <Index.TableContainer
                                          component={Index.Paper}
                                          className="table-container"
                                        >
                                          <Index.Table className="table-design-main barge-table">
                                            <Index.TableHead>
                                              <Index.TableRow>
                                                <Index.TableCell>
                                                  Description
                                                </Index.TableCell>
                                                <Index.TableCell align="right">
                                                  Amount
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </Index.TableHead>
                                            <Index.TableBody>
                                              {getViewData?.medicalSahay
                                                ?.medicationExpenses?.length >
                                              0 ? (
                                                getViewData.medicalSahay.medicationExpenses.map(
                                                  (expense, index) => (
                                                    <Index.TableRow key={index}>
                                                      <Index.TableCell>
                                                        {expense?.description ||
                                                          "-"}
                                                      </Index.TableCell>
                                                      <Index.TableCell align="right">
                                                        ₹
                                                        {expense?.amount || "0"}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )
                                              ) : (
                                                <Index.TableRow>
                                                  <Index.TableCell
                                                    colSpan={2}
                                                    align="center"
                                                  >
                                                    No data available
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              )}
                                            </Index.TableBody>
                                          </Index.Table>
                                        </Index.TableContainer>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Hospital Expenses (હોસ્પિટલ
                                                ખર્ચ)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid item xs={12}>
                                        <Index.TableContainer
                                          component={Index.Paper}
                                          className="table-container"
                                        >
                                          <Index.Table className="table-design-main barge-table">
                                            <Index.TableHead>
                                              <Index.TableRow>
                                                <Index.TableCell>
                                                  Description
                                                </Index.TableCell>
                                                <Index.TableCell align="right">
                                                  Amount
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </Index.TableHead>
                                            <Index.TableBody>
                                              {getViewData?.medicalSahay
                                                ?.hospitalExpenses?.length >
                                              0 ? (
                                                getViewData.medicalSahay.hospitalExpenses.map(
                                                  (expense, index) => (
                                                    <Index.TableRow key={index}>
                                                      <Index.TableCell>
                                                        {expense?.description ||
                                                          "-"}
                                                      </Index.TableCell>
                                                      <Index.TableCell align="right">
                                                        ₹
                                                        {expense?.amount || "0"}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )
                                              ) : (
                                                <Index.TableRow>
                                                  <Index.TableCell
                                                    colSpan={2}
                                                    align="center"
                                                  >
                                                    No data available
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              )}
                                            </Index.TableBody>
                                          </Index.Table>
                                        </Index.TableContainer>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Hospital Stay Details */}
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Hospital Stay Details
                                                (હોસ્પિટલમાં રોકાણ)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Hospital Class (હોસ્પિટલ વર્ગ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.hospitalClass || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Hospital Days (દિવસો)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.hospitalDays || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Daily Charge (દૈનિક ચાર્જ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.dailyCharge || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          ICU Days (ICU દિવસો)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.icuDays || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          ICU Daily Charge (ICU દૈનિક ચાર્જ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.icuDailyCharge || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Treatment Reason (સારવારનું કારણ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.treatmentReason || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Mediclaim Policy Details */}
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Mediclaim Policy Details
                                                (મેડિક્લેમ પોલિસી વિગત)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Mediclaim Policy Taken (મેડિક્લેમ
                                          પોલિસી લીધી છે)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.mediclaimPolicyTaken === "yes"
                                                ? "Yes (હા)"
                                                : "No (ના)"
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      {getViewData?.medicalSahay
                                        ?.mediclaimPolicyTaken === "yes" && (
                                        <Index.Grid
                                          item
                                          xs={12}
                                          sm={6}
                                          md={4}
                                          lg={4}
                                        >
                                          <Index.Typography
                                            variant="label"
                                            component="label"
                                            className="input-label"
                                          >
                                            Policy Amount (પોલિસી રકમ)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border">
                                            <Index.TextField
                                              hiddenLabel
                                              variant="filled"
                                              className="admin-input-design input-placeholder"
                                              disabled
                                              value={
                                                getViewData?.medicalSahay
                                                  ?.mediclaimPolicyAmount || ""
                                              }
                                            />
                                          </Index.Box>
                                        </Index.Grid>
                                      )}

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Association Mediclaim Taken (સંસ્થા
                                          મેડિક્લેમ લીધી)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.associationMediclaimTaken ===
                                              "yes"
                                                ? "Yes (હા)"
                                                : "No (ના)"
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      {getViewData?.medicalSahay
                                        ?.mediclaimNotTakenReason && (
                                        <Index.Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={12}
                                        >
                                          <Index.Typography
                                            variant="label"
                                            component="label"
                                            className="input-label"
                                          >
                                            Reason for Not Taking Mediclaim
                                            (મેડિક્લેમ ન લેવાનું કારણ)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border">
                                            <Index.TextField
                                              hiddenLabel
                                              variant="filled"
                                              className="admin-input-design input-placeholder"
                                              disabled
                                              multiline
                                              rows={2}
                                              value={
                                                getViewData?.medicalSahay
                                                  ?.mediclaimNotTakenReason ||
                                                ""
                                              }
                                            />
                                          </Index.Box>
                                        </Index.Grid>
                                      )}
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Known Person Details */}
                                {/* <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="main-card-box">
                                    <Index.Grid container spacing={2}>
                                      <Index.Grid item xs={12} sm={12} md={12}>
                                        <Index.Box className="title-header">
                                          <Index.Box className="title-header-flex">
                                            <Index.Box className="title-main">
                                              <Index.Typography
                                                variant="p"
                                                component="p"
                                                className="page-title"
                                              >
                                                Known Person Details (જાણીતી
                                                વ્યક્તિની વિગત)
                                              </Index.Typography>
                                            </Index.Box>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        lg={3}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Full Name (પુરું નામ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.knownPersonFullName || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        lg={3}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Residence (નિવાસ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.knownPersonResidence || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        lg={3}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Neighborhood (પડોશ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.knownPersonNeighborhood || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        lg={3}
                                      >
                                        <Index.Typography
                                          variant="label"
                                          component="label"
                                          className="input-label"
                                        >
                                          Mobile (મોબાઇલ)
                                        </Index.Typography>
                                        <Index.Box className="input-design-div with-border">
                                          <Index.TextField
                                            hiddenLabel
                                            variant="filled"
                                            className="admin-input-design input-placeholder"
                                            disabled
                                            value={
                                              getViewData?.medicalSahay
                                                ?.knownPersonMobile || ""
                                            }
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Grid> */}

                                {/* Detailed Bills - Medicine */}
                                <Index.Grid item xs={12} md={12}>
                                  <Index.Box className="title-header" mt={5}>
                                    <Index.Box className="title-header-flex res-title-header-flex">
                                      <Index.Box className="title-main">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Medicine Bills Details (દવાના બિલોની
                                          વિગત)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box className="">
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table
                                        aria-label="simple table"
                                        className="table-design-main barge-table"
                                      >
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Medical Store (મેડિકલ સ્ટોર)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Date (તારીખ)
                                            </Index.TableCell>
                                            <Index.TableCell align="right">
                                              Amount (રકમ)
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.medicineBillsDetails?.length >
                                          0 ? (
                                            getViewData.medicalSahay.medicineBillsDetails.map(
                                              (bill, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {bill?.medicalStoreName ||
                                                      "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {bill?.date || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell align="right">
                                                    ₹{bill?.amount || "0"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                colSpan={3}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Diagnosis Bills */}
                                <Index.Grid item xs={12} md={12}>
                                  <Index.Box className="title-header" mt={5}>
                                    <Index.Box className="title-header-flex res-title-header-flex">
                                      <Index.Box className="title-main">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Diagnosis Bills (નિદાન બિલો)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box className="">
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table
                                        aria-label="simple table"
                                        className="table-design-main barge-table"
                                      >
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Laboratory (પ્રયોગશાળા)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Date (તારીખ)
                                            </Index.TableCell>
                                            <Index.TableCell align="right">
                                              Amount (રકમ)
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.diagnosisBillsDetails?.length >
                                          0 ? (
                                            getViewData.medicalSahay.diagnosisBillsDetails.map(
                                              (bill, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {bill?.laboratoryName ||
                                                      "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {bill?.date || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell align="right">
                                                    ₹{bill?.amount || "0"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                colSpan={3}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Hospital Bills */}
                                <Index.Grid item xs={12} md={12}>
                                  <Index.Box className="title-header" mt={5}>
                                    <Index.Box className="title-header-flex res-title-header-flex">
                                      <Index.Box className="title-main">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Hospital Bills (હોસ્પિટલ બિલો)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box className="">
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table
                                        aria-label="simple table"
                                        className="table-design-main barge-table"
                                      >
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Details (વિગત)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Date (તારીખ)
                                            </Index.TableCell>
                                            <Index.TableCell align="right">
                                              Amount (રકમ)
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.hospitalBillsDetails?.length >
                                          0 ? (
                                            getViewData.medicalSahay.hospitalBillsDetails.map(
                                              (bill, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {bill?.details || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {bill?.date || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell align="right">
                                                    ₹{bill?.amount || "0"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                colSpan={3}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Box>
                                </Index.Grid>

                                {/* Other Expenses */}
                                <Index.Grid item xs={12} md={12}>
                                  <Index.Box className="title-header" mt={5}>
                                    <Index.Box className="title-header-flex res-title-header-flex">
                                      <Index.Box className="title-main">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Other Expenses (અન્ય ખર્ચા)
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                  <Index.Box className="">
                                    <Index.TableContainer
                                      component={Index.Paper}
                                      className="table-container"
                                    >
                                      <Index.Table
                                        aria-label="simple table"
                                        className="table-design-main barge-table"
                                      >
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              Details (વિગત)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Date (તારીખ)
                                            </Index.TableCell>
                                            <Index.TableCell align="right">
                                              Amount (રકમ)
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          {getViewData?.medicalSahay
                                            ?.otherExpensesDetails?.length >
                                          0 ? (
                                            getViewData.medicalSahay.otherExpensesDetails.map(
                                              (expense, index) => (
                                                <Index.TableRow key={index}>
                                                  <Index.TableCell>
                                                    {expense?.details || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell>
                                                    {expense?.date || "-"}
                                                  </Index.TableCell>
                                                  <Index.TableCell align="right">
                                                    ₹{expense?.amount || "0"}
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              ),
                                            )
                                          ) : (
                                            <Index.TableRow>
                                              <Index.TableCell
                                                colSpan={3}
                                                align="center"
                                              >
                                                No data available
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          )}
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  </Index.Box>
                                </Index.Grid>

                                {/* External Assistance */}
                                {getViewData?.medicalSahay
                                  ?.receivedExternalAssistance === "yes" && (
                                  <Index.Grid item xs={12} md={12}>
                                    <Index.Box className="title-header" mt={5}>
                                      <Index.Box className="title-header-flex res-title-header-flex">
                                        <Index.Box className="title-main">
                                          <Index.Typography
                                            variant="p"
                                            component="p"
                                            className="page-title"
                                          >
                                            External Assistance (બાહ્ય સહાય)
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                    </Index.Box>
                                    <Index.Box className="">
                                      <Index.TableContainer
                                        component={Index.Paper}
                                        className="table-container"
                                      >
                                        <Index.Table
                                          aria-label="simple table"
                                          className="table-design-main barge-table"
                                        >
                                          <Index.TableHead>
                                            <Index.TableRow>
                                              <Index.TableCell>
                                                Organization Name (સંસ્થાનું
                                                નામ)
                                              </Index.TableCell>
                                              <Index.TableCell align="right">
                                                Amount (રકમ)
                                              </Index.TableCell>
                                            </Index.TableRow>
                                          </Index.TableHead>
                                          <Index.TableBody>
                                            {getViewData?.medicalSahay
                                              ?.externalAssistanceDetails
                                              ?.length > 0 ? (
                                              getViewData.medicalSahay.externalAssistanceDetails.map(
                                                (assistance, index) => (
                                                  <Index.TableRow key={index}>
                                                    <Index.TableCell>
                                                      {assistance?.organizationName ||
                                                        "-"}
                                                    </Index.TableCell>
                                                    <Index.TableCell align="right">
                                                      ₹
                                                      {assistance?.amount ||
                                                        "0"}
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                ),
                                              )
                                            ) : (
                                              <Index.TableRow>
                                                <Index.TableCell
                                                  colSpan={2}
                                                  align="center"
                                                >
                                                  No data available
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            )}
                                          </Index.TableBody>
                                        </Index.Table>
                                      </Index.TableContainer>
                                    </Index.Box>
                                  </Index.Grid>
                                )}
                              </>
                            )}

                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Family Members Details (પરિવારના સભ્યોની
                                      વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table "
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Name (નામ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Age (ઉંમર)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Relation (સંબંધ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Working Type (કામ કરવાનો પ્રકાર)
                                        </Index.TableCell>
                                        {/* <Index.TableCell align="left">
                                          {" "}
                                          Monthly Income
                                        </Index.TableCell> */}
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.relationRecords?.length ? (
                                        getViewData?.relationRecords?.map(
                                          (data, index) => {
                                            return (
                                              <Index.TableRow key={index}>
                                                <Index.TableCell>
                                                  {data?.name}
                                                </Index.TableCell>

                                                <Index.TableCell align="left">
                                                  {data?.age}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.relation}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.workingType}
                                                </Index.TableCell>
                                                {/* <Index.TableCell align="left">
                                                  {data?.monthlyIncome}
                                                </Index.TableCell> */}
                                              </Index.TableRow>
                                            );
                                          },
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            scope="row"
                                            className="no-data-in-list"
                                            colSpan={6}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>
                            {/* <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Trust
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table "
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell align="left">
                                          Trust Name
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Account
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.trustRecords?.length ? (
                                        getViewData?.trustRecords?.map(
                                          (data, index) => {
                                            return (
                                              <Index.TableRow key={index}>
                                                <Index.TableCell align="left">
                                                  {data?.trustName}
                                                </Index.TableCell>

                                                <Index.TableCell align="left">
                                                  {data?.ammount}
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            );
                                          }
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            scope="row"
                                            className="no-data-in-list"
                                            colSpan={2}
                                            align="center"
                                          >
                          
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid> */}
                            {getViewData?.application[0]?.committeeRemark ||
                            getViewData?.application[0]?.staffRemark ? (
                              <>
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="title-header">
                                    <Index.Box className="title-header-flex">
                                      <Index.Box className="title-main ">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Remarks
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={6} sm={6} md={6} lg={6}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    {/* Claimed Sahay Amount */}
                                    Committee Remark
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.committeeRemark || "-"
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={6} sm={6} md={6} lg={6}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    {/* Claimed Sahay Amount */}
                                    Staff Remark
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.staffRemark || "-"
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </>
                            ) : (
                              <></>
                            )}

                            {/* table */}
                          </Index.Grid>

                          <Index.Box className="line" mt={3} mb={3}></Index.Box>
                        </Index.Box>
                      </form>
                    )}
                  </PagesIndex.Formik>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
};

export default ApplyForSahayView;
